import React, { useCallback, useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import Sidebar from "../comman/Sidebar";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import {
  Button,
  ButtonGroup,
  Checkbox,
  Chip,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Popover,
  Select,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import { amber, red } from "@mui/material/colors";

import Pagination from "@mui/material/Pagination";
import {
  CustomMessage,
  deCryptFun,
  enCryptFun,
} from "../comman/CustomFunction";
import personIcon from "../../images/person.svg";
import PersonOffOutlinedIcon from "@mui/icons-material/PersonOffOutlined";
import {
  BROKER_TO_ADMIN_URL,
  FORGET_PASSWORD_URL,
  USER_RESEND_EMAIL_URL,
} from "../../constants/ApiRoute";
import {
  authHeader,
  getLogUserId,
  getLogUserRole,
} from "../comman/MainFunction";
import {
  UPDATE_USER_BY_ID,
  USERS_BY_ID_URL,
  ARCHIVE_STATUS_UPDATE_URL,
} from "../../constants/ApiRoute";
import * as Yup from "yup";
import { useFormik } from "formik";
import API from "../comman/API";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { userRole as roledata, userRole } from "../comman/Constant";
import { useNavigate, useLocation } from "react-router-dom";
import { USERS_ROUTE } from "../../constants/RoutePath";
import CustomToast from "../comman/CustomToast";
import EmailSchema from "../comman/validation/EmailSchema";
import { useToast } from "../comman/CustomMessages";
import UserArchiveUnarchiveConfirm from "../model/UserArchiveUnarchiveConfirm";
import UserAccountDeactivateConfirm from "../model/UserAccountDeactivateConfirm";
import EmailResendConfirmation from "../model/EmailResendConfirmation";
import AdminBrokerConfirmation from "./AdminBrokerConfirmation";
import {
  allowedCharactersRegex,
  phoneNumberRegex,
} from "../comman/RegexConstant";
import Navbar from "../comman/Navbar";
import moment from "moment";
import { USER_ACTIVE_TYPE } from "../../redux/action/ActionType";
import { useDispatch, useSelector } from "react-redux";
import VerifiedIcon from "../../images/verified.svg";
import userSharing from "../../images/user-sharing.svg";
import CustomPageLoading from "../comman/CustomPageLoading";
import { getLoggedUserDetails } from "../../redux/action";
import debounce from "lodash/debounce";
import { AdminCloseIcon } from "../../images/SvgIcons";
import InformationEmailPopUp from "../model/InformationEmailPopUp";
import UserAccountActivateConfirm from "../model/UserAccountActivateConfirm";

const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  userName: "",
  phoneNumber: "",
  emailConfirmed: "",
  adminApproved: "",
  accountActive: "",
  userRole: "",
  failedCount: "",
  lockoutEndDateUtc: "",
};

const unarchiveUserStyle = {
  backgroundColor: amber[700],
  color: "white",
  marginRight: "10px",
};

const archiveUserStyle = {
  backgroundColor: red[700],
  color: "white",
  marginRight: "10px",
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const names = [
  "Oliver Hansen",
  "Van Henry",
  "April Tucker",
  "Ralph Hubbard",
  "Omar Alexander",
  "Carlos Abbott",
  "Miriam Wagner",
  "Bradley Wilkerson",
  "Virginia Andrews",
  "Kelly Snyder",
];

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const UserDetails = () => {
  const pathname = window.location.pathname;
  const parts = pathname.split("/");
  const id = parts[parts.length - 1];
  const cleanId = id.split("%")[0];
  const location = useLocation();
  const showToast = useToast();
  const [editFlag, setFlag] = useState(true);
  const theme = useTheme();
  const [personName, setPersonName] = React.useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [oldSelectedRoles, setOldSelectedRole] = useState([]);
  const [accountArchive, setAccountArchive] = useState(0);
  const [accountArchiveConfirm, setAccountArchiveConfirm] = useState(false);
  const [roleChange, setRoleChange] = useState(false);
  const [accountActiveChange, setAccountActiveChange] = useState(false);
  const [accountActiveTrueChange, setAccountActiveTrueChange] = useState(false);
  const [flag, setAdvFlag] = useState(true);
  const [adminRemove, setAdminRemove] = useState(false);
  const [brokerroleadded, setBrokeradded] = useState(false);
  const [displayName, setDisplayName] = useState("");
  console.log(displayName, "dispaaaaaaaaas");
  const [oldEmail, setOldEmail] = useState("");
  const [mailChange, setMailChange] = useState(false);
  const [informationEmailpopup, setInfromationEmailpopup] = useState(false);
  const [pendingBadge, setPendingBadge] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resendEmailConfirmation, setResendEmailConfirmation] = useState(false);
  const [resendEmailData, setResendEmailData] = useState("");
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const isActive = deCryptFun(useSelector((s) => s.ActiveUserReducer));
  let val = isActive && JSON.parse(isActive);
  console.log("isA", isActive && JSON.parse(isActive).active);
  const [anchorEl1, setAnchorEl1] = useState(null); // State for first popover
  const [anchorEl2, setAnchorEl2] = useState(null); // State for second popover
  const [isProjectFormUpdated, setIsProjectFormUpdated] = useState(false);
  const [getSaveEmail, setGetSavedEmail] = useState("");
  const [inputGenrationKeyCopy, setInputGenrationKeyCopy] = useState("");
  const [sendButtonLoading, setSendButtonLoading] = useState(false);
  const [linkCopyItem, setLinkCopyItem] = React.useState();
  const [generateButtonLoading, setGenerateButtonLoading] =
    React.useState(false);

  // Handlers for first popover
  const handleClick1 = (event) => {
    setAnchorEl1(event.currentTarget);
  };

  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  const open1 = Boolean(anchorEl1);
  const id1 = open1 ? "popover1" : undefined;

  // Handlers for second popover
  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  const handleCopy = () => {
    if (linkCopyItem) {
      navigator.clipboard.writeText(linkCopyItem);
    }
  };

  const open2 = Boolean(anchorEl2);
  const id2 = open2 ? "popover2" : undefined;
  const getLogUserRoleArray = JSON.parse(getLogUserRole());
  var isOnlyAdmin = false;
  if (
    getLogUserRoleArray &&
    getLogUserRoleArray?.length > 0 &&
    getLogUserRoleArray.includes("Admin")
  ) {
    isOnlyAdmin = true;
  }
  const validationSchema = Yup.object({
    firstName: Yup.string()
      .trim()
      .required("First name is required")
      .matches(
        allowedCharactersRegex,
        "First name should only contain alphabetic characters"
      )
      .min(1, "First name must be at least 1 character")
      .max(50, "First name cannot exceed 50 characters"),
    lastName: Yup.string()
      .trim()
      .required("Last name is required")
      .matches(
        allowedCharactersRegex,
        "Last name should only contain alphabetic characters"
      )
      .min(1, "Last name must be at least 1 character")
      .max(50, "Last name cannot exceed 50 characters"),
    email: EmailSchema.required("Email is required"),
    userName: Yup.string().trim().required("User name is required"),
    // .matches(allowedCharactersRegex, "Invalid")
    // .min(1, "User name must be at least 1 character")
    // .max(50, "User name cannot exceed 50 characters"),
    phoneNumber: Yup.string()
      .trim()
      .required("Phone number is required")
      .matches(phoneNumberRegex, "Invalid phone number")
      .min(7, "Invalid phone number")
      .max(15, "Invalid phone number"),
    // emailConfirmed: Yup.string().required("Last name is required"),
    // adminApproved: Yup.string().required("Last name is required"),
    // accountActive: Yup.string().required("Last name is required"),
    userRole: Yup.string().required("Role is required"),
    // failedCount: Yup.string().required("Last name is required"),
  });
  const {
    handleSubmit,
    handleChange,
    setValues,
    setFieldValue,
    values,
    errors,
    setErrors,
    touched,
    resetForm,
    validateForm,
    setFieldTouched,
    handleBlur,
  } = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      // if (getSaveEmail !== values.email) {
      //   setInfromationEmailpopup(true);
      // } else {
      // if(values.accountActive == 1){
      //   brokerRemoveFun()
      // }else{
      Updateuser(values);
      // }
      // }
    },
  });
  console.log("users", values);

  const ForgotPasswordUser = async () => {
    setSendButtonLoading(true);
    const postData = {
      email: values.email,
      linkUrl: window.location.origin + "/changepassword/",
    };

    const config = {
      method: "PUT",
      url: FORGET_PASSWORD_URL,
      data: {
        webString: enCryptFun(JSON.stringify(postData)),
        flutterString: "",
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status == "Success") {
        showToast("Password reset email sent successfully.", "success");
        setSendButtonLoading(false);
        getUserByDetails();
        setLinkCopyItem("");
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
        setSendButtonLoading(false);
      }
    } finally {
      setSendButtonLoading(false);
      //resetForm();
    }
  };

  const Updateuser = async () => {
    const {
      firstName,
      lastName,
      email,
      phoneNumber,
      userName,
      userRole,
      emailConfirmed,
      adminApproved,
      accountActive,
    } = values;
    let luid = getLogUserId();
    console.log(userName, "userNameuserNameuserName");
    if (luid == cleanId) {
      let userNAme = userName.trim();

      localStorage.setItem("LOG_USER_NAME", enCryptFun(userNAme));
    }

    const d1 = {
      userId: cleanId,
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      email: email,
      phoneNumber: phoneNumber,
      userName: userName.trim(),
      userRole: personName ? personName.join(",") : "",
      emailConfirmed: mailChange == true ? false : emailConfirmed,
      adminApproved: adminApproved,
      accountActive: accountActive == false ? 0 : 1,
      Luid: luid,
    };

    console.log("luid", luid);
    console.log("d1", d1);

    const config = {
      method: "PUT",
      url: UPDATE_USER_BY_ID,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(d1)),
        flutterString: "",
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        if (mailChange) {
          let emailResendData = {
            userId: cleanId,
            firstName: firstName.trim(),
            lastName: lastName.trim(),
            email: email,
            linkUrl: window.location.origin + "/email-confirmation/",
          };

          emailResendMailFunc(emailResendData);
        }

        showToast(parsedResponse.message, "success");
        getUserByDetails();
        setFlag(true);
        setIsProjectFormUpdated(false);
        setAccountActiveTrueChange(false);
      }
    } catch (error) {
      console.log("error", error);
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
      }
    } finally {
    }
  };

  const emailResendMailFunc = async (emailResendData) => {
    const configEmailSend = {
      method: "POST",
      url: USER_RESEND_EMAIL_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(emailResendData)),
        flutterString: "",
      },
    };

    try {
      const response = await API(configEmailSend);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        showToast(
          `${values.firstName} ${values.lastName} (${values.email}) email has been updated. This account will be locked out until this user clicks the email confirmation link sent to their email address.`,
          "emailSent"
        );
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
      }
    } finally {
      setMailChange(false);
    }
  };

  const getUserByDetails = async () => {
    const d1 = {
      userId: cleanId,
    };
    const config = {
      method: "GET",
      url: USERS_BY_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(d1)),
      },
    };

    try {
      setLoading(true);
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status == "Success") {
        const {
          FirstName,
          LastName,
          Email,
          UserName,
          EmailConfirmed,
          PhoneNumber,
          AccessFailedCount,
          AdminApproved,
          AccountActive,
          AccountArchive,
          UserRole,
          LockoutEndDateUtc,
          ForgotPasswordSentDate,
          isForgotPasswordSent,
          passwordUpdatedDate,
        } = parsedResponse.data[0];
        const fullName = `${FirstName} ${LastName}`;
        if (UserRole == null) {
          setPersonName([]);
          setSelectedRoles([]);
        }
        setDisplayName(fullName);
        let datauser = {
          userId: cleanId,
          active: AccountActive,
        };
        setGetSavedEmail(Email);
        setValues({
          firstName: FirstName,
          lastName: LastName,
          emailConfirmed: EmailConfirmed,
          phoneNumber: PhoneNumber,
          email: Email,
          userName: UserName,
          adminApproved: AdminApproved == 0 ? false : true,
          accountActive: AccountActive,
          userRole: UserRole,
          failedCount: AccessFailedCount,
          lockoutEndDateUtc: LockoutEndDateUtc
            ? moment(LockoutEndDateUtc).format("MM/DD/YYYY")
            : "",
          ForgotPasswordSentDate: ForgotPasswordSentDate
            ? moment.utc(ForgotPasswordSentDate).format("MM/DD/YYYY HH:mm:ss") // 24-hour format
            : "",
          isForgotPasswordSent: isForgotPasswordSent,
          passwordUpdatedDate: passwordUpdatedDate
            ? moment.utc(passwordUpdatedDate).format("MM/DD/YYYY HH:mm:ss") // 24-hour format
            : "",
        });
        setAccountArchive(AccountArchive);
        setOldEmail(Email);
        const rolesArray = UserRole.split(",");
        console.log("roles", rolesArray);
        setPersonName(rolesArray);
        const selectedRoles = roledata
          .filter((role) => UserRole.includes(role.id))
          .map((role) => role.role);
        setSelectedRoles(selectedRoles);
        setOldSelectedRole(selectedRoles);

        setResendEmailData({
          userId: cleanId,
          firstName: FirstName,
          lastName: LastName,
          email: Email,
          linkUrl: window.location.origin + "/email-confirmation/",
        });
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (cleanId) {
      getUserByDetails();
    }
  }, [cleanId]);

  const resendEmailConfirmationFunc = async (value) => {
    let decryptedUserId = deCryptFun(value);
    const decryptedUserIdJson = JSON.parse(decryptedUserId);

    const config1 = {
      method: "GET",
      url: USERS_BY_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify({ userId: decryptedUserIdJson })),
      },
    };

    try {
      const response1 = await API(config1);
      let decryptedResponse1 = deCryptFun(response1.data);
      const parsedResponse1 = JSON.parse(decryptedResponse1);

      console.log("parsedResponse1", parsedResponse1);

      if (parsedResponse1.status === "Success") {
        const {
          UserId,
          FirstName,
          LastName,
          Email,
          UserName,
          PhoneNumber,
          UserRole,
          AdminApproved,
          AccountActive,
        } = parsedResponse1.data[0];

        const d1 = {
          userId: UserId,
          firstName: FirstName,
          lastName: LastName,
          email: Email,
          phoneNumber: PhoneNumber,
          userName: UserName,
          userRole: UserRole,
          emailConfirmed: true,
          adminApproved: AdminApproved,
          accountActive: AccountActive,
          Luid: "",
        };

        const config = {
          method: "PUT",
          url: UPDATE_USER_BY_ID,
          headers: authHeader(),
          data: {
            webString: enCryptFun(JSON.stringify(d1)),
            flutterString: "",
          },
        };

        try {
          const response = await API(config);
          let decryptedResponse = deCryptFun(response.data);
          const parsedResponse = JSON.parse(decryptedResponse);
          if (parsedResponse.status === "Success") {
            showToast(
              "Email confirmation was successfully updated.",
              "success"
            );
            navigation("/user-details/" + cleanId);
          }
        } catch (error) {
          if (error.response) {
            let { data } = error.response;
            let p = deCryptFun(data);
            let v = JSON.parse(p);
            showToast(v.message, "error");
          }
        }
      }
    } catch (error) {}
  };

  useEffect(() => {
    // Create a URLSearchParams instance to get query parameters
    const queryParams = new URLSearchParams(location.search);
    const value = queryParams.get("value"); // Get the value of the 'value' parameter

    console.log("value-->", value);

    if (value) {
      resendEmailConfirmationFunc(value);
    }
  }, [location]);

  const handleChanges = (event) => {
    const {
      target: { value },
    } = event;

    // Handle multiple selections or empty value
    const selectedIds = typeof value === "string" ? value.split(",") : value;
    setPersonName(selectedIds);

    // Update selectedRoles based on selected IDs
    const roles = selectedIds.map((id) => {
      const role = roledata.find((r) => r.id === id);
      return role ? role.role : [];
    });
    setSelectedRoles(roles);

    // Update Formik values and trigger validation
    setFieldValue("userRole", selectedIds.join(","));
  };

  console.log("user role", userRole, personName);
  const editFun = () => {
    setFlag(false);
    setIsProjectFormUpdated(true);
    getUserByDetails();
  };
  const BackFun = () => {
    navigation(USERS_ROUTE);
  };
  const handleChangeEmail = (e) => {
    // Remove all spaces from the input
    const newValue = e.target.value.replace(/\s/g, "");

    let isSame = oldEmail.trim().toLowerCase() === newValue.toLowerCase();
    console.log("isSame", isSame, oldEmail, newValue);

    if (!isSame) {
      setMailChange(true);
    } else {
      setMailChange(false);
    }

    handleChange({
      target: {
        name: e.target.name,
        value: newValue,
      },
    });
  };

  // const handleChangeEmail = useCallback(
  //   debounce((e) => {
  //     const newEmail = e.target.value.trim().toLowerCase();
  //     const isSame = oldEmail.trim().toLowerCase() === newEmail;
  //     setMailChange(!isSame);
  //     if (!isSame) {
  //       setPendingBadge(true);
  //     } else {
  //       setPendingBadge(false);
  //     }
  //   }, 300),
  //   []
  // );

  const handleBlurEmail = (e) => {
    // Check if the email has changed
    const isSame =
      getSaveEmail.trim().toLowerCase() === e.target.value.trim().toLowerCase();
    console.log(isSame, "isSameeeeeeeeeeeeeeee");
    if (!isSame && !errors.email) {
      setMailChange(true);
      setInfromationEmailpopup(true);
      // showToast(
      //   "Changing your email address will require the user to verify the new email address.",
      //   "warning",
      //   { autoClose: 5000 } // Set the duration to 5 seconds
      // );
    } else {
      setMailChange(false);
    }

    handleBlur(e); // Call the Formik's handleBlur function to handle formik's touched state
  };

  const handleDelete = (r) => {
    let re = selectedRoles.filter((rec) => rec != r);
    console.log("removed", re);
    setSelectedRoles(re);
    const selectedIds = typeof r === "string" ? r.split(",") : r;
    console.log("selec", selectedIds);
    const roles = re.map((id) => {
      const role = roledata.find((r) => r.role == id);
      return role ? role.id : [];
    });
    setPersonName(roles);
    setValues({ ...values, userRole: roles.join(",") });
    console.log("roles", roles);
  };

  const handleClose = () => {
    setRoleChange(false);
    console.log("false set");
  };
  const brokerRemoveFun = async (revert) => {
    console.log(brokerroleadded, "ereeeeeeeeeeeeeeeeeeeeeee");
    let postData = {
      userId: cleanId,
      isRevert: revert == 1 ? 1 : 0,
    };

    // if (values.accountActive == "0") {
    //   postData.isRevert = 0;
    // }
    // if (values.accountActive == 1) {
    //   postData.isRevert = 1;
    // }

    // if (brokerroleadded) {
    //   postData.isRevert = 1;
    // }

    // if (!brokerroleadded) {
    //   postData.isRevert = 0;
    // }

    const config = {
      method: "POST",
      url: BROKER_TO_ADMIN_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(postData)),
      },
    };
    if (adminRemove == false) {
      try {
        const response = await API(config);
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);
        if (parsedResponse.status === "Success") {
          // showToast("Removed successfully", "success");
          setAdvFlag(false);
          setRoleChange(false);
        }
      } catch (error) {
        if (error.response) {
          let { data } = error.response;
          let p = deCryptFun(data);
          let v = JSON.parse(p);
          //  showToast(v.message, "error");
          setAdvFlag(false);
          setRoleChange(false);
        }
      } finally {
        handleSubmit();
      }
    } else {
      setAdvFlag(false);
      setRoleChange(false);
      handleSubmit();
    }
  };
  console.log(
    getSaveEmail,
    "I have updated as 2PM IST to client",
    values.email
  );
  const handleSaveClick = () => {
    const addedRoles = selectedRoles.filter(
      (role) => !oldSelectedRoles.includes(role)
    );
    const removedRoles = oldSelectedRoles.filter(
      (role) => !selectedRoles.includes(role)
    );

    const brokerRemoved = removedRoles.includes("Broker");
    const adminAdded = addedRoles.includes("Admin");
    const adminRemoved = removedRoles.includes("Admin");
    const brokeradded = addedRoles.includes("Broker");
    console.log(brokeradded, "ereeeeeeeeeeeeeeeeeeeeeeewwwwwwwwwwww");
    // Prioritize Admin role changes
    if (values.userRole == "") {
      validateForm();
    } else {
      if (adminRemoved && !brokerRemoved) {
        setBrokeradded(false);
        setAdminRemove(true);
        setRoleChange(true);
        setAdvFlag(true);
      } else if (brokerRemoved && !adminAdded) {
        setBrokeradded(false);
        setAdvFlag(true);
        setRoleChange(true);
        setAdminRemove(false);
      } else if (adminAdded && brokerRemoved) {
        setBrokeradded(false);
        setAdvFlag(false);
        setRoleChange(true);
        setAdminRemove(false);
      } else if (brokeradded) {
        setBrokeradded(brokeradded);
        // handleSubmit()
        brokerRemoveFun(1);
      } else {
        setBrokeradded(false);
        handleSubmit(); // Proceed with submitting the form
      }
    }
    // setIsProjectFormUpdated(false);
  };

  const userAccountDeactivateConfirmFunc = async (value, revert) => {
    console.log(value, "valueeeeeeeeeeeeeee");
    if (value == "no") {
      setValues({ ...values, accountActive: true });
    } else if (value == "yes") {
      setValues({ ...values, accountActive: false });
      // handleSubmit()
      brokerRemoveFun(0);
    }
    // brokerRemoveFun(revert)
  };

  const userAccountActivateConfirmFunc = async (value, revert) => {
    if (value == "no") {
      setValues({ ...values, accountActive: false });
    } else if (value == "yes") {
      setValues({ ...values, accountActive: true });
      // handleSubmit()
      brokerRemoveFun(1);
    }
    // brokerRemoveFun(revert)
  };

  const handleAccountArchive = async (value) => {
    console.log(value, "valuevaluevalue");
    let luid = localStorage.getItem("LOG_USER_ID");
    let obj = {
      userId: cleanId,
      accountArchive: value,
      Luid: deCryptFun(luid),
    };

    const config = {
      method: "PUT",
      url: ARCHIVE_STATUS_UPDATE_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(obj)),
        flutterString: "",
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        // showToast("User updated successfully", "success");
        if (value == 1) {
          setValues({ ...values, accountActive: false });
          brokerRemoveFun(0);
        } else {
          setValues({ ...values, accountActive: true });
          brokerRemoveFun(1);
        }
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
      }
    } finally {
      // getUserByDetails();
    }
  };
  const handleActiveUser = (e, type) => {
    console.log("e.ta", e.target.checked, type);
    let sel = e.target.checked;
    console.log(sel, "sellllllllll");
    let datauser = {
      userId: cleanId,
      active: sel,
    };
    if (type == "yes") {
      setValues({ ...values, accountActive: sel });
      // dispatch({
      //   type: USER_ACTIVE_TYPE,
      //   payload: enCryptFun(JSON.stringify(datauser)),
      // });
    } else {
      setValues({ ...values, accountActive: sel == true ? false : true });
      let datauserno = {
        userId: cleanId,
        active: sel == true ? false : true,
      };
      // dispatch({
      //   type: USER_ACTIVE_TYPE,
      //   payload: enCryptFun(JSON.stringify(datauserno)),
      // });
    }

    var isExistBroker = selectedRoles.includes("Broker");
    if (type == "no" && sel == true && isExistBroker) {
      setAccountActiveChange(true);
      setAccountActiveTrueChange(false);
    } else if (type == "yes" && sel == true && isExistBroker) {
      setAccountActiveTrueChange(true);
      setAccountActiveChange(false);
    } else {
      setAccountActiveChange(false);
      setAccountActiveTrueChange(false);
    }
  };

  const handleInformationPopup = () => {
    handleSubmit();
    setInfromationEmailpopup(false);

    // setFlag(true);
  };
  const handleInformationClose = () => {
    setValues({ ...values, email: oldEmail });
    setInfromationEmailpopup(false);
  };

  // Email  Resenr
  const handleEmailResend = async (value) => {
    console.log("value", value);

    if (value.popuptype == "resent_email") {
      const config1 = {
        method: "GET",
        url: USERS_BY_ID_URL,
        headers: authHeader(),
        params: {
          webString: enCryptFun(
            JSON.stringify({
              userId: cleanId,
            })
          ),
        },
      };

      try {
        setLoading(true);
        const response = await API(config1);
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);
        if (parsedResponse.status == "Success") {
          const { FirstName, LastName, Email } = parsedResponse.data[0];

          // Resend Email Section Start

          let resendEmailDataObj = {
            userId: cleanId,
            firstName: FirstName,
            lastName: LastName,
            email: Email,
            linkUrl: window.location.origin + "/email-confirmation/",
          };

          const configResendEmail = {
            method: "POST",
            url: USER_RESEND_EMAIL_URL,
            headers: authHeader(),
            data: {
              webString: enCryptFun(JSON.stringify(resendEmailDataObj)),
              flutterString: "",
            },
          };

          try {
            const responseResendEmail = await API(configResendEmail);
            let decryptedResponseResendEmail = deCryptFun(
              responseResendEmail.data
            );
            const parsedResponseResendEmail = JSON.parse(
              decryptedResponseResendEmail
            );
            if (parsedResponseResendEmail.status === "Success") {
              showToast("Email confirmation sent successfully", "success");
            }
          } catch (error) {
            if (error.response) {
              let { data } = error.response;
              let p = deCryptFun(data);
              let v = JSON.parse(p);
              showToast(v.message, "error");
            }
          } finally {
            setResendEmailConfirmation(false);
          }

          console.log("resendEmailData", FirstName, LastName, Email);
        }
      } catch (error) {
      } finally {
        setResendEmailConfirmation(false);
        setLoading(false);
      }
    } else {
      setResendEmailConfirmation(false);
    }
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlesClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlesClose = () => {
    setAnchorEl(null);
  };

  const handlessClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const opens = Boolean(anchorEl);

  const handleChange1 = (e) => {
    const { name, value } = e.target;

    // Trim leading and trailing spaces and allow only valid characters
    // Remove any invalid characters except spaces and letters
    let cleanedValue = value.replace(/[^a-zA-Z\s'-]/g, "");
    // Prevent space as the first character
    if (
      cleanedValue === " " ||
      (cleanedValue?.length === 1 && cleanedValue.startsWith(" "))
    ) {
      cleanedValue = "";
    }

    // Enforce a maximum character limit of 50
    if (cleanedValue.length > 50) {
      cleanedValue = cleanedValue.slice(0, 50);
    }

    // Update Formik's value
    setValues((prevValues) => ({
      ...prevValues,
      [name]: cleanedValue,
    }));

    // Optionally, you can also set touched and errors if needed
    setFieldTouched(name, true);
  };

  const formatPhoneNumber = (value) => {
    if (!value) return value;

    // Remove all non-digits except the + sign
    const phoneNumber = value.replace(/[^\d]/g, "");

    if (phoneNumber.length < 4) return `(${phoneNumber}`;
    if (phoneNumber.length < 7)
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    if (phoneNumber.length <= 10)
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
        3,
        6
      )}-${phoneNumber.slice(6)}`;

    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  };

  const handlePhoneNumberChange = (e) => {
    const { value } = e.target;
    console.log(value, "valueurrrrrrrrrrrrr");
    // Allow valid characters: digits, spaces, parentheses, dashes, and the plus sign
    const allowedCharactersRegex = /^[\d\s()+-]*$/;

    if (allowedCharactersRegex.test(value)) {
      console.log(value, "valueurrvaluevaluerrrrrrrrrrr");
      // Format the phone number as the user types
      const formattedPhoneNumber = formatPhoneNumber(value);
      console.log(
        formattedPhoneNumber,
        "formattedPhoneNumberformattedPhoneNumber"
      );
      // Update Formik's state with the formatted value
      handleChange(e);
      setValues({
        ...values,
        phoneNumber: formattedPhoneNumber,
      });
    }
  };

  useEffect(() => {
    // window.history.pushState(null, null, window.location.pathname);
    const handlePopState = () => {
      localStorage.setItem("USER_PAGE_BACKBUTTON_CLICK", true);
      navigation(USERS_ROUTE);
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);
  const handleCancel = () => {
    getUserByDetails();
    setFlag(true);
    setIsProjectFormUpdated(false);
    setInfromationEmailpopup(false);
  };

  const GeneratePasswordLink = async () => {
    setGenerateButtonLoading(true);
    const postData = {
      email: values.email,
      linkUrl: window.location.origin + "/changepassword/",
      isGenerateLink: true,
    };

    const config = {
      method: "PUT",
      url: FORGET_PASSWORD_URL,
      data: {
        webString: enCryptFun(JSON.stringify(postData)),
        flutterString: "",
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      if (parsedResponse.status === "Success") {
        const { linkUrl } = parsedResponse;
        console.log(linkUrl, "API response link", parsedResponse); // Logs API response
        showToast("Link generated successfully.", "success");
        // Update state using functional update
        setLinkCopyItem(linkUrl);
        getUserByDetails();
        setGenerateButtonLoading(false);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
        setGenerateButtonLoading(false);
      }
    } finally {
      setGenerateButtonLoading(false);
    }
  };

  return (
    <>
      <Box sx={{ display: "-webkit-box" }}>
        <Sidebar higlightSide={"6"} />

        <Box component="main" sx={{ flexGrow: 1, p: "18px 20px" }}>
          <Navbar title={displayName} backFlag={true} backRoute={USERS_ROUTE} />
          <Box sx={{ pl: "33px", pr: "33px" }} className="bg-box user-log">
            <Stack
              sx={{ mb: 2 }}
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid container>
                <Grid xs={12} md={9}>
                  <Typography
                    sx={{ mb: { xs: "15px", sm: "0px" } }}
                    className="personal-title"
                  >
                    Personal Details
                  </Typography>
                </Grid>
                <Grid
                  xs={12}
                  md={3}
                  style={{ float: "right", textAlign: "right" }}
                >
                  {isOnlyAdmin && !isProjectFormUpdated && (
                    <Button
                      className={
                        cleanId == getLogUserId()
                          ? "defaultarchive-btn"
                          : !accountArchive
                          ? "archive-btn"
                          : "unarchive-btn"
                      }
                      sx={{
                        backgroundColor: accountArchive ? "#EC7100" : "#df0000",
                      }}
                      startIcon={
                        <span class="material-symbols-outlined">
                          {!accountArchive ? "person_off" : "person"}
                        </span>
                      }
                      variant="contained"
                      // style={
                      //   accountArchive ? unarchiveUserStyle : archiveUserStyle
                      // }
                      onClick={() => {
                        setAccountArchiveConfirm(true);
                      }}
                      disabled={cleanId == getLogUserId()}
                    >
                      {!accountArchive ? "Archive User" : "Unarchive User"}
                    </Button>
                  )}

                  {editFlag == false ? (
                    <Button
                      sx={{ minWidth: "auto", maxWidth: "58px", width: "100%" }}
                      className="primary-btn user-save-btn"
                      variant="outlined"
                      type="submit"
                      color="success"
                      onClick={handleSaveClick}
                    >
                      Save
                    </Button>
                  ) : (
                    <Button
                      className="edit-btn"
                      variant="outlined"
                      startIcon={
                        <span class="material-symbols-outlined">edit</span>
                      }
                      onClick={editFun}
                    >
                      Edit
                    </Button>
                  )}
                  {isProjectFormUpdated && (
                    <Button
                      sx={{
                        minWidth: "auto",
                        maxWidth: "74px",
                        width: "100%",
                        height: "40px",
                        border: "none",
                        marginLeft: "10px",
                      }}
                      className="cancel-btn"
                      variant="outlined"
                      type="submit"
                      color="success"
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Stack>
            <Box className="user-details-form">
              <Stack
                direction={{ xs: "column", sm: "row" }}
                alignItems={{ xs: "flex-end", sm: "flex-start" }}
                spacing={{ xs: 0, sm: 4, md: 7.5 }}
              >
                <FormControl variant="standard">
                  <p className="label">First Name:</p>
                  <Input
                    name="firstName"
                    id="firstName"
                    value={values.firstName}
                    onChange={handleChange1}
                    onBlur={handleBlur}
                    disabled={editFlag}
                    startAdornment={
                      <InputAdornment position="start">
                        <img src={personIcon} />
                      </InputAdornment>
                    }
                    error={errors.firstName && touched.firstName}
                    helperText={
                      errors.firstName && touched.firstName
                        ? errors.firstName
                        : ""
                    }
                  />
                  <FormHelperText error={true}>
                    {errors.firstName && touched.firstName
                      ? errors.firstName
                      : ""}
                  </FormHelperText>
                </FormControl>

                <FormControl variant="standard">
                  <p className="label">Last Name:</p>
                  <Input
                    name="lastName"
                    id="lastName"
                    value={values.lastName}
                    onChange={handleChange1}
                    onBlur={handleBlur}
                    disabled={editFlag}
                    startAdornment={
                      <InputAdornment position="start">
                        <img src={personIcon} />
                      </InputAdornment>
                    }
                    error={errors.lastName && touched.lastName}
                    helperText={
                      errors.lastName && touched.lastName ? errors.lastName : ""
                    }
                  />
                  <FormHelperText error={true}>
                    {errors.lastName && touched.lastName ? errors.lastName : ""}
                  </FormHelperText>
                </FormControl>
              </Stack>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                alignItems={{ xs: "flex-end", sm: "flex-start" }}
                spacing={{ xs: 2, sm: 4, md: 7.5 }}
              >
                <FormControl
                  variant="standard"
                  className={
                    !values.emailConfirmed && !errors.email
                      ? "email-not-confirm"
                      : ""
                  }
                >
                  <p className="label">Email:</p>
                  <Input
                    name="email"
                    id="email"
                    value={values.email}
                    onChange={handleChangeEmail}
                    onBlur={handleBlurEmail}
                    disabled={editFlag}
                    startAdornment={
                      <InputAdornment position="start">
                        <span className="material-symbols-outlined">mail</span>
                      </InputAdornment>
                    }
                    endAdornment={
                      <InputAdornment sx={{ color: "#58A84A" }} position="end">
                        {values.emailConfirmed && !pendingBadge && (
                          <img src={VerifiedIcon} alt="Verified" />
                        )}
                        {pendingBadge && <span>Pending</span>}
                      </InputAdornment>
                    }
                    error={errors.email && touched.email}
                    helperText={
                      errors.email && touched.email ? errors.email : ""
                    }
                  />
                  <FormHelperText>
                    {!values.emailConfirmed && !errors.email ? (
                      <span style={{ color: "rgb(255 217 0)" }}>
                        Email Not Verified
                      </span>
                    ) : (
                      ""
                    )}
                  </FormHelperText>
                  <FormHelperText error={true}>
                    {errors.email && touched.email ? errors.email : ""}
                  </FormHelperText>
                </FormControl>
                <FormControl variant="standard">
                  <p className="label">User Name:</p>
                  <Input
                    name="userName"
                    id="userName"
                    value={values.userName}
                    onChange={handleChange}
                    disabled={editFlag}
                    startAdornment={
                      <InputAdornment position="start">
                        <img src={userSharing} />
                      </InputAdornment>
                    }
                    error={errors.userName && touched.userName}
                    helperText={
                      errors.userName && touched.userName ? errors.userName : ""
                    }
                  />
                  <FormHelperText error={true}>
                    {errors.userName && touched.userName ? errors.userName : ""}
                  </FormHelperText>
                </FormControl>
              </Stack>
              <FormControl
                sx={{
                  width: { xs: "100% !important", md: "47.5% !important" },
                }}
                variant="standard"
              >
                <p className="label">Phone Number:</p>
                <Input
                  name="phoneNumber"
                  id="phoneNumber"
                  value={values.phoneNumber}
                  onChange={handlePhoneNumberChange}
                  disabled={editFlag}
                  startAdornment={
                    <InputAdornment position="start">
                      <span class="material-symbols-outlined">call</span>
                      <span className="country-code">+1</span>
                    </InputAdornment>
                  }
                  error={errors.phoneNumber && touched.phoneNumber}
                  helperText={
                    errors.phoneNumber && touched.phoneNumber
                      ? errors.phoneNumber
                      : ""
                  }
                />
                <FormHelperText error={true}>
                  {errors.phoneNumber && touched.phoneNumber
                    ? errors.phoneNumber
                    : ""}
                </FormHelperText>
              </FormControl>
            </Box>
            <Stack
              className="user-checkbox"
              sx={{ width: { xs: "100%", md: "80%" } }}
              direction={{ xs: "column", sm: "row" }}
              alignItems={{ xs: "baseline", sm: "flex-start" }}
              spacing={2}
              justifyContent="space-between"
            >
              <Box>
                <p style={{ marginBottom: "0px" }} className="label">
                  Email Confirmed:
                </p>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="flex-start"
                  spacing={2}
                >
                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        name="emailConfirmed"
                        id="emailConfirmedYes"
                        onChange={handleChange}
                        // disabled={editFlag || cleanId == getLogUserId()}
                        disabled={true}
                        sx={{ color: "gray" }}
                        checked={values.emailConfirmed === true}
                      />
                    }
                    label="Yes"
                  />

                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        name="emailConfirmed"
                        id="emailConfirmedNo"
                        onChange={() =>
                          setValues({ ...values, emailConfirmed: false })
                        }
                        sx={{ color: "gray" }}
                        // disabled={editFlag || cleanId == getLogUserId()}
                        disabled
                        checked={values.emailConfirmed === false}
                      />
                    }
                    label="No"
                  />
                </Stack>
                <Typography
                className="resend-email"
                onClick={() => {
                  if (!values.emailConfirmed && values.email == oldEmail) {
                    setResendEmailConfirmation(true);
                  }
                }}
                style={
                  values.emailConfirmed || values.email != oldEmail
                    ? { color: "gray" }
                    : {}
                }
              >
                <Tooltip
                  className="project-tooltip"
                  title={
                    values.email !== oldEmail
                      ? ""
                      : !values.emailConfirmed
                      ? "Click to Resend Email Confirmation"
                      : "Account Verified"
                  }
                  placement="top"
                >
                  Resend Email Confirmation
                </Tooltip>
              </Typography>
              </Box>
              <Box>
                <p style={{ marginBottom: "0px" }} className="label">
                  Admin Approved:
                </p>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="flex-start"
                  spacing={2}
                >
                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        className={
                          cleanId == getLogUserId() ? "disable-btn" : ""
                        }
                        name="adminApproved"
                        id="adminApprovedYes"
                        onChange={handleChange}
                        sx={{ color: "gray" }}
                        disabled={editFlag || cleanId == getLogUserId()}
                        checked={values.adminApproved == true}
                      />
                    }
                    label="Yes"
                  />

                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        name="adminApproved"
                        id="adminApprovedNo"
                        disabled={editFlag || cleanId == getLogUserId()}
                        onChange={() =>
                          setValues({ ...values, adminApproved: false })
                        }
                        sx={{ color: "gray" }}
                        checked={values.adminApproved == false}
                      />
                    }
                    label="No"
                  />
                </Stack>
              </Box>
              <Box>
                <p style={{ marginBottom: "0px" }} className="label">
                  Account Active:
                </p>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="flex-start"
                  spacing={2}
                >
                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        name="accountActive"
                        id="accountActiveYes"
                        // onChange={handleChange}
                        data-acc="yes"
                        onChange={(e) => {
                          handleActiveUser(e, "yes");
                        }}
                        disabled={editFlag || cleanId == getLogUserId()}
                        sx={{ color: "gray" }}
                        checked={
                          values.accountActive == true ||
                          (values.accountActive && values.accountActive == 1)
                        }
                      />
                    }
                    label="Yes"
                  />

                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        name="accountActive"
                        id="accountActiveNo"
                        disabled={editFlag || cleanId == getLogUserId()}
                        onChange={(e) => {
                          handleActiveUser(e, "no");
                        }}
                        data-acc="no"
                        sx={{ color: "gray" }}
                        checked={
                          values.accountActive == false ||
                          (values.accountActive && values.accountActive == 0)
                        }
                      />
                    }
                    label="No"
                  />
                </Stack>
              </Box>
            </Stack>

            <FormControl
              sx={{ width: { xs: "100%", md: "47.5%" }, mt: "25px" }}
              variant="standard"
              error={Boolean(errors.userRole && touched.userRole)} // This line marks the form control as having an error
            >
              <p className="label">Grant User Role:</p>
              <Select
                className="grant-user-field"
                sx={{ height: "40px" }}
                name="userRole"
                id="userRole"
                error={errors.userRole && touched.userRole}
                value={personName.filter((r) => r != null)}
                onChange={(event) => handleChanges(event)}
                multiple
                displayEmpty
                IconComponent={KeyboardArrowDownIcon}
                disabled={editFlag}
                input={<OutlinedInput />}
                startAdornment={
                  <InputAdornment position="start">
                    <span
                      style={{ fontSize: "20px", lineHeight: 1 }}
                      className="material-symbols-outlined"
                    >
                      person
                    </span>
                  </InputAdornment>
                }
                MenuProps={MenuProps}
                inputProps={{ "aria-label": "Without label" }}
                renderValue={(selected) => {
                  if (selected?.length === 0) {
                    return (
                      <Typography className="place-text">
                        Enter User Role
                      </Typography>
                    );
                  }
                  return selectedRoles.join(", "); // Customize the display of selected values as needed
                }}
              >
                {roledata.map((name) => (
                  <MenuItem
                    key={name.id}
                    value={name.id}
                    style={getStyles(name.id, personName, theme)}
                  >
                    {name.role}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText error={true}>
                {errors.userRole && touched.userRole ? errors.userRole : ""}
              </FormHelperText>
              <Stack direction="row" spacing={1} alignItems="center">
                {selectedRoles &&
                  selectedRoles.map((r) => {
                    return !editFlag ? (
                      <Chip
                        sx={{ height: "28px" }}
                        className={
                          r === "Admin" ? "role-chip admin" : "role-chip broker"
                        }
                        variant="outlined"
                        data-rolename={r}
                        disabled={editFlag}
                        onDelete={() => {
                          handleDelete(r);
                          setFieldTouched("userRole", true);
                        }}
                        label={r}
                        // deleteIcon={<AdminCloseIcon />}
                      />
                    ) : (
                      <Chip
                        sx={{ height: "28px" }}
                        className={
                          r === "Admin" ? "role-chip admin" : "role-chip broker"
                        }
                        variant="outlined"
                        data-rolename={r}
                        label={r}
                      />
                    );
                  })}
              </Stack>
            </FormControl>
            <Stack
              sx={{ width: { xs: "100%", md: "100%" }, mt: "22px !important" }}
              direction={{ xs: "column", sm: "row" }}
              spacing={4}
              alignItems={{ xs: "baseline", sm: "flex-start" }}
              // justifyContent="space-between"
            >
              <Stack
                sx={{ width: { xs: "100%", md: "47.5%" } }}
                direction="row"
                alignItems="flex-start"
                justifyContent="space-between"
                spacing={2}
              >
                <Box className="reset-labels">
                  <Box sx={{ display: "flex" }}>
                    <p className="label">Account Lock: </p>
                    <span
                      aria-describedby={id1}
                      onClick={handleClick1}
                      style={{
                        color: "#898989",
                        fontSize: "15px",
                        // position: "absolute",
                        marginLeft: "4px",
                        cursor: "pointer",
                        marginTop: "2px",
                      }}
                      className="material-symbols-outlined"
                    >
                      help
                    </span>
                  </Box>
                  <Popover
                    className="account-lock-info"
                    id={id1}
                    open={open1}
                    anchorEl={anchorEl1}
                    onClose={handleClose1}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                  >
                    <Typography
                      sx={{ textAlign: "left", p: 2 }}
                      className="popover-text"
                    >
                      This is the date and time of the last time this account
                      was locked out due to excessive failed login attempts. If
                      this date is in the past then the user is no longer logged
                      out.
                    </Typography>
                  </Popover>
                  <Typography sx={{ fontSize: "14px" }}>
                    {values.lockoutEndDateUtc ? values.lockoutEndDateUtc : "-"}
                  </Typography>
                </Box>

                <Box>
                  <Box sx={{ display: "flex" }}>
                    <p className="label">Failed Login Count: </p>
                    <span
                      aria-describedby={id2}
                      onClick={handleClick2}
                      style={{
                        color: "#898989",
                        fontSize: "15px",
                        // position: "absolute",
                        marginLeft: "4px",
                        cursor: "pointer",
                        marginTop: "2px",
                      }}
                      className="material-symbols-outlined"
                    >
                      help
                    </span>
                  </Box>
                  <Popover
                    className="account-faild-count"
                    id={id2}
                    open={open2}
                    anchorEl={anchorEl2}
                    onClose={handleClose2}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                  >
                    <Typography
                      sx={{ textAlign: "left", p: 0 }}
                      className="popover-text"
                    >
                      This is the number of recent failed login attempts by this
                      user.
                    </Typography>
                  </Popover>
                  <Typography sx={{ mt: "0px !important" }} className="count">
                    {values.failedCount}
                  </Typography>
                </Box>

                {/* <Box>
                  <p className="label">
                    Reset Request Status & Last Reset Request (UTC):
                  </p>
                  {!loading ? (
                    values?.isForgotPasswordSent == "Email Not Sent" ? (
                      <Chip
                        sx={{
                          height: "30px",
                          marginTop: "0px !important",
                          padding: "7px 14px",
                        }}
                        className="role-chip admin"
                        variant="outlined"
                        data-rolename={"-"}
                        label={"-"}
                      />
                    ) : values?.isForgotPasswordSent == "Email Sent" ? (
                      <Chip
                        sx={{
                          height: "32px",
                          marginTop: "0px !important",
                          padding: "7px 14px",
                        }}
                        className="role-chip admin"
                        variant="outlined"
                        data-rolename={`${values?.isForgotPasswordSent} - ${
                          values?.ForgotPasswordSentDate || "-"
                        }`}
                        label={`${values?.isForgotPasswordSent} &  ${
                          values?.ForgotPasswordSentDate || "-"
                        }`}
                      />
                    ) : (
                      <Chip
                        sx={{
                          height: "32px",
                          marginTop: "0px !important",
                          padding: "7px 14px",
                        }}
                        className="role-chip admin"
                        variant="outlined"
                        data-rolename={`${values?.isForgotPasswordSent} - ${
                          values?.ForgotPasswordSentDate || "-"
                        }`}
                        label={`${values?.isForgotPasswordSent} &  ${
                          values?.ForgotPasswordSentDate || "-"
                        }`}
                      />
                    )
                  ) : (
                    "-"
                  )}
                </Box>

                <Box>
                  <p className="label">Password Updated (UTC):</p>
                  <Chip
                    sx={{
                      height: "30px",
                      marginTop: "0px !important",
                      padding: "7px 14px",
                    }}
                    className="role-chip admin"
                    variant="outlined"
                    data-rolename={values?.passwordUpdatedDate || "-"}
                    label={values?.passwordUpdatedDate || "-"}
                  />
                </Box> */}
              </Stack>
              {/* <Stack
                sx={{
                  width: {
                    xs: "100%",
                    md: "47.5%",
                    marginLeft: "70px !important",
                  },
                }}
                direction="row"
                alignItems="flex-start"
                justifyContent="space-around"
                spacing={2}
              >
                <Box>
                  <p className="label">
                    Reset Request Status & Last Reset Request(UTC):
                  </p>
                  {values?.isForgotPasswordSent == "Email Not Sent" ? (
                    <Chip
                      sx={{ height: "30px", marginTop: "0px !important" }}
                      className="role-chip emailnotsent"
                      variant="outlined"
                      data-rolename={values?.isForgotPasswordSent || '-'}
                      label={values?.isForgotPasswordSent || '-'}
                    />
                  ) : values?.isForgotPasswordSent == "Email Sent" ? (
                    <Chip
                      sx={{display: 'flex', height: "30px", marginTop: "0px !important" }}
                      className="role-chip admin"
                      variant="outlined"
                      data-rolename={`${values?.isForgotPasswordSent} - ${
                        values?.ForgotPasswordSentDate || "-"
                      }`}
                      label={`${values?.isForgotPasswordSent} &  ${
                        values?.ForgotPasswordSentDate || "-"
                      }`}
                    />
                  ) : (
                    <Chip
                      sx={{ height: "30px", marginTop: "0px !important" }}
                      className="role-chip admin"
                      variant="outlined"
                      data-rolename={`${values?.isForgotPasswordSent} - ${
                        values?.ForgotPasswordSentDate || "-"
                      }`}
                      label={`${values?.isForgotPasswordSent} &  ${
                        values?.ForgotPasswordSentDate || "-"
                      }`}
                    />
                  )}
                </Box>
              </Stack> */}
            </Stack>
            {loading && <CustomPageLoading />}
          </Box>
          {roleChange && (
            <AdminBrokerConfirmation
              open={roleChange}
              flag={flag}
              brokerRemoveFun={brokerRemoveFun}
              handleClose={handleClose}
              adminRemove={adminRemove}
            />
          )}

          {accountArchiveConfirm && (
            <UserArchiveUnarchiveConfirm
              open={accountArchiveConfirm}
              accountArchive={accountArchive}
              selectedRoles={selectedRoles}
              brokerRemoveFun={brokerRemoveFun}
              setAccountArchiveConfirm={setAccountArchiveConfirm}
              handleAccountArchive={handleAccountArchive}
            />
          )}

          {accountActiveChange && (
            <UserAccountDeactivateConfirm
              open={accountActiveChange}
              brokerRemoveFun={brokerRemoveFun}
              setAccountActiveChange={setAccountActiveChange}
              userAccountDeactivateConfirmFunc={
                userAccountDeactivateConfirmFunc
              }
            />
          )}
          {accountActiveTrueChange && (
            <UserAccountActivateConfirm
              open={accountActiveTrueChange}
              brokerRemoveFun={brokerRemoveFun}
              setAccountActiveTrueChange={setAccountActiveTrueChange}
              userAccountActivateConfirmFunc={userAccountActivateConfirmFunc}
            />
          )}

          {resendEmailConfirmation && (
            <EmailResendConfirmation
              open={resendEmailConfirmation}
              sendItem={{ popuptype: "resent_email" }}
              modelPopUpYesNoFunc={handleEmailResend}
              title={"Email Resend Confirmation"}
              bodyMessage={
                "Are you sure you want to resend the email confirmation?"
              }
            />
          )}
          {informationEmailpopup && (
            <InformationEmailPopUp
              open={informationEmailpopup}
              sendItem={{ popuptype: "resent_email" }}
              handleInformationPopup={handleInformationPopup}
              handleClose={handleInformationClose}
              // title={"Email Information"}
            />
          )}
        </Box>
      </Box>
      <Box sx={{ display: "flex" }}>
        <Sidebar highlightSide={"5"} />
        <Box
          component="main"
          sx={{ flexGrow: 1, p: "18px 20px", paddingTop: "0px" }}
        >
          <Box
            sx={{
              p: 4,
              borderRadius: 1,
              backgroundColor: "white",
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              mb={3}
            >
              <Typography
                sx={{ mb: { xs: "15px", sm: "0px" } }}
                className="personal-title"
              >
                Reset Password
              </Typography>
            </Stack>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              alignItems={{ xs: "flex-start", sm: "center" }}
              sx={{ mb: "2rem" }}
            >
              {" "}
              <Box sx={{ minWidth: "34rem" }}>
                <Button
                  className={
                    !sendButtonLoading ? "filter-btn" : "disable-filter-btn"
                  }
                  onClick={() => {
                    ForgotPasswordUser();
                  }}
                  disabled={sendButtonLoading}
                  variant="contained"
                >
                  {sendButtonLoading && (
                    <CircularProgress
                      color={"inherit"}
                      size={10}
                      sx={{ marginRight: "3px" }}
                    />
                  )}
                  Send Email
                </Button>
                <Button
                  sx={{ marginLeft: "2rem" }}
                  className={
                    generateButtonLoading || linkCopyItem
                      ? "disable-filter-btn"
                      : "filter-btn"
                  }
                  onClick={() => {
                    GeneratePasswordLink();
                  }}
                  disabled={linkCopyItem}
                >
                  {generateButtonLoading && (
                    <CircularProgress
                      color={"inherit"}
                      size={10}
                      sx={{ marginRight: "3px" }}
                    />
                  )}
                  Generate Link
                </Button>
                <Box sx={{ marginTop: "2rem" }}>
                  <p className="label">
                    Reset Request Status & Last Reset Request (UTC):
                  </p>
                  {!loading ? (
                    values?.isForgotPasswordSent == "Email Not Sent" ? (
                      <Chip
                        sx={{ height: 30, px: 2 }}
                        // className="role-chip emailnotsent"
                        className="role-chip admin"
                        variant="outlined"
                        data-rolename={"-"}
                        label={"-"}
                      />
                    ) : values?.isForgotPasswordSent == "Email Sent" ? (
                      <Chip
                        sx={{
                          height: "32px",
                          marginTop: "0px !important",
                          padding: "7px 7px",
                        }}
                        className="role-chip admin"
                        variant="outlined"
                        data-rolename={`${values?.isForgotPasswordSent} at ${
                          values?.ForgotPasswordSentDate || "-"
                        }`}
                        label={`${values?.isForgotPasswordSent} at  ${
                          values?.ForgotPasswordSentDate || "-"
                        }`}
                      />
                    ) : (
                      <Chip
                      sx={{
                        height: "32px",
                        marginTop: "0px !important",
                        padding: "7px 7px",
                      }}
                      className="role-chip admin"
                      variant="outlined"
                      data-rolename={
                        !values?.isForgotPasswordSent && !values?.ForgotPasswordSentDate
                          ? "-"
                          : `${values?.isForgotPasswordSent || "-"} at ${values?.ForgotPasswordSentDate || "-"}`
                      }
                      label={
                        !values?.isForgotPasswordSent && !values?.ForgotPasswordSentDate
                          ? "-"
                          : `${values?.isForgotPasswordSent || "-"} at ${values?.ForgotPasswordSentDate || "-"}`
                      }
                    />                    
                    )
                  ) : (
                    "-"
                  )}
                </Box>
              </Box>
              <Box>
                {linkCopyItem && (
                  <TextField
                    variant="outlined"
                    value={linkCopyItem || ""} // Show the generated key
                    sx={{ minWidth: "28rem", maxWidth: "20rem", width: "100%" }}
                    InputProps={{
                      readOnly: true, // Prevent editing
                      endAdornment: (
                        <InputAdornment position="end">
                          <Tooltip title="Copy" onClick={handleCopy}>
                            <IconButton edge="end">
                              <ContentCopyIcon sx={{ width: "18px" }}  />
                            </IconButton>
                          </Tooltip>
                        </InputAdornment>
                      ),
                    }}
                    disabled
                    fullWidth
                  />
                )}

                <Box sx={{ marginRight: "5rem", marginTop: linkCopyItem ? "2rem" : '4rem'}}>
                  <p className="label">Password Updated (UTC):</p>
                  <Chip
                    sx={{ height: 30, px: 1, marginTop: "0px !important" }}
                    className="role-chip admin"
                    variant="outlined"
                    label={values?.passwordUpdatedDate || "-"}
                  />
                </Box>
              </Box>
            </Stack>
            {loading && <CustomPageLoading />}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default UserDetails;
